import React, { Fragment } from "react";
import Cookies from "js-cookie";
import Lightbox from "react-image-lightbox";
import {
  Button,
  FormGroup,
  Input,
  Col,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Label,
  Container,
  Alert,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import api from "../../api";

import Select from "react-select";
import SiteTextInput from "components/SiteTextInput";
import SiteDropdownInput from "components/SiteDropdownInput";
import constants from "../../constants";
import "./index.css";
import PhotoPlaceholder from "resources/images/photo_placeholder.jpg";
import Image from "pages/Site/components/Image";
import ApiCaller from "api/apiCaller";

const STATUS_FILTER = [
  { label: "All", value: "all" },
  //   { label: "Draft", value: "draft" },
  //   { label: "Approved", value: "approved" },
  //   { label: "Waiting for approval", value: "waiting_for_approval" },
  { label: "Đang xây dựng", value: "under-construction" },
  { label: "Đang hoạt động", value: "complete" },
  { label: "Đã đóng cửa", value: "closed" },
];

// The Roster component matches one of two different routes
// depending on the full pathname
export default class MarketInformationEditScreen extends React.Component {
  constructor(props) {
    super(props);
    const site = this.props.site
      ? this.props.site
      : this.props.location.state
      ? this.props.location.state.site
      : null;
    this.state = {
      attachmentToUploads: [],
      existingAttachmentsToUpdate: [],
      isCreate:
        window.location.href.includes("market_information/create") || false,
      site: site || {
        id: parseInt(this.props.match.params.location_id, 10) || "",
        // is_site_dev_location: 0,
        description: "",
        name: "",
        // segment_query: '',
        changed_by: Cookies.get("current_user_id"),
        created_by: Cookies.get("current_user_id"),
        brand: {
          id: site && site.brand ? site.brand.id : "",
          name: site && site.brand ? site.brand.name : "",
        },
        location_type: {
          id: site && site.location_type ? site.location_type.id : "",
          name: site && site.location_type ? site.location_type.name : "",
        },
        external_status: (site && site.external_status) || "",
        showLightBox: false,
        lightBoxPhotoIndex: 0,
        lightBoxImageArray: [],
      },
      activeTab: "1",
      labelNames: this.props.labelNames || [],
      isLoading: false,
      isUploading: false,
      isView: this.props.isView || false,
      selectedPhotos: null,
      selectedCaptions: {},
      renderGroupList: this.createRenderGroupList(
        site ? site.location_type : { id: 0 }
      ),
      selectedStatus: STATUS_FILTER.find((item) => {
        return item.value === (site ? site.external_status : "");
      }),
      customAttributeData:
        site && site.custom_attribute_data
          ? JSON.parse(site.custom_attribute_data)
          : {},
      customAttributeInfo: [],
      showLightBox: false,
      photoIndex: 0,
    };
    this.updateAttr = this.updateAttr.bind(this);
    const randomString = Math.random().toString(36).substring(7);
    this.fileInputId = `${Date.now().toString()}-${randomString}`;
  }

  UNSAFE_componentWillMount() {
    const { isCreate } = this.state;
    this.getCurrentUser();
    if (isCreate) {
      const { site } = this.state;
      this.getSiteFieldInfo();
      this.getCustomAttributeInfo(site.location_type.id);
    } else {
      // If not site is passed, only then should we call the API
      if (!this.props.site) {
        this.getSiteDetail();
        this.getSiteFieldInfo();
      } else {
        const { site } = this.state;
        this.getCustomAttributeInfo(site.location_type.id);
      }
    }
  }

  //   componentDidMount() {

  //   }
  //   componentDidMount = () => {
  //     if (this.props.site) {
  //       this.setState({
  //         site: this.props.site,
  //         labelNames: this.props.labelNames
  //       });
  //     }
  //   };
  // componentDidUpdate(prevProps) {
  //   if (prevProps.site !== this.props.site) {
  //     this.setState({
  //       site: this.props.site
  //     });
  //   }

  //   if (prevProps.labelNames !== this.props.labelNames) {
  //     this.setState({
  //       labelNames: this.props.labelNames
  //     });
  //   }
  // }
  createRenderGroupList(locationType) {
    switch (locationType.id) {
      case 1: // Coffe Shop
        return ["1a", "1b", "2", "3", "4", "5", "6", "7", "8a"];
      case 11: // Wet market
        return ["1a", "5", "6", "8c"];
      case 8: // Apartment
        return ["1a", "5", "8d"];
      case 10: // Convenience Store
        return ["1a", "1b", "2", "3", "4", "5", "6", "7", "8b"];
      case 3: // Shopping Mall / Plaza
        return ["1a", "1b", "2", "3", "4", "5", "6", "7", "8e"];
      default:
        return ["1a", "1b", "2", "3", "4", "5", "6", "7"];
    }
  }
  validateSiteInfoCheck() {
    const { site, labelNames } = this.state;
    const alertMessage = [];
    constants.MARRKET_LOCATION_SITE_REQUIRED_FIELDS.map((requiredField) => {
      if (!site[requiredField]) {
        const fieldName = labelNames[requiredField];
        alertMessage.push(`${fieldName} không được để trống`);
      }
    });
    if (alertMessage) {
      this.setState({
        alertMessage,
      });
    } else {
      alert("Everything is good");
    }
  }
  getCurrentUser() {
    api.fetchAPI({
      method: "get",
      uri: `userme/me`,
      success: (response) => {
        if (response.result) {
          const currentUser = response.result;
          const { site } = this.state;

          // if (currentUser.user_brand) {
          //   site.brand.id = currentUser.user_brand.brand_id;
          // }

          this.setState({
            currentUser,
            // site
          });
        } else {
          alert("Failed to get user: " + response.msg);
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  getSiteFieldInfo() {
    api.fetchAPI({
      method: "get",
      uri: `location/_info`,
      success: (response) => {
        const labelNames = {};
        response.edit_columns.map((eachColumn) => {
          if (
            !eachColumn.label.includes("địa điểm mặt bằng") &&
            eachColumn.label.includes("mặt bằng")
          ) {
            labelNames[eachColumn.name] = eachColumn.label.replace(
              "mặt bằng",
              "địa điểm"
            );
          } else {
            labelNames[eachColumn.name] = eachColumn.label;
          }
        });
        this.setState({
          labelNames,
          isLoading: false,
        });
      },
      error: (error) => {
        console.error(error);
        this.setState({ isLoading: false });
      },
    });
  }
  getSiteDetail() {
    const { site } = this.state;
    this.setState({ isLoading: true });
    api.fetchAPI({
      method: "get",
      uri: `location/${site.id}`,
      success: async (response) => {
        this.getCustomAttributeInfo(response.result.location_type.id);
        this.setState({
          renderGroupList: this.createRenderGroupList(
            response.result.location_type
          ),
          selectedStatus: STATUS_FILTER.find((item) => {
            return item.value === response.result.external_status;
          }),
          customAttributeData: response.result.custom_attribute_data
            ? JSON.parse(response.result.custom_attribute_data)
            : {},
          site: response.result,
          labelNames: response.label_columns,
          isLoading: false,
        });
      },
      error: (error) => {
        console.error(error);
        this.setState({ isLoading: false });
      },
    });
  }
  getCustomAttributeInfo(location_type_id) {
    const { site } = this.state;
    this.setState({ isLoading: true });
    api.fetchAPI({
      method: "get",
      uri: `location_attribute/?q=(filters:!((col:location_type,opr:rel_o_m,value:${location_type_id})))`,
      success: (response) => {
        this.setState({
          customAttributeInfo: response.result,
          isLoading: false,
          selectedStatus: STATUS_FILTER.find((item) => {
            return item.value === (site ? site.external_status : "");
          }),
        });
      },
      error: (error) => {
        console.error(error);
        this.setState({ isLoading: false });
      },
    });
  }
  saveSite(exitAfterSave) {
    const { site, isCreate, currentUser, alertMessage } = this.state;

    this.validateSiteInfoCheck();

    if (isCreate) {
      site.created_by = {
        id: currentUser.id,
      };
      site.is_site_dev_location = 0;
    }

    site.changed_by = {
      id: currentUser.id,
    };

    this.setState({ isLoading: true });

    api.fetchAPI({
      method: isCreate ? "post" : "put",
      uri: isCreate ? "location/" : `location/${site.id}`,
      body: site,
      success: async (response) => {
        console.log(response);
        if (response.result) {
          // On create, update a few data
          if (isCreate) {
            site.id = response.id;
          }
          // Upload photos, if any
          await this.uploadImage().then(() => {
            if (exitAfterSave)
              window.location = `/market_information/${site.id}`;
          });
          this.setState({
            isUploading: false,
            isLoading: false,
          });
        }
      },
      error: (error) => {
        console.log(error);
        alert(error.msg);
        this.setState({ isLoading: false });
      },
    });
    this.setState({ isLoading: false });
  }
  async uploadImage() {
    const {
      site,
      attachmentToUploads,
      existingAttachmentsToUpdate,
    } = this.state;
    this.setState({ isUploading: true });

    const promiseAll = [];
    // Upload new attachments
    if (attachmentToUploads.length > 0) {
      attachmentToUploads.forEach(async (attachment) => {
        var attachmentFormData = new FormData();
        attachmentFormData.append("user_file", attachment.blob);
        attachmentFormData.append(
          "caption_text",
          attachment.captionText || null
        );
        attachmentFormData.append(
          "legal_document_id",
          attachment.legalDocumentId || null
        );
        promiseAll.push(
          ApiCaller.post(
            `location_attachment/${site.id}`,
            attachmentFormData
          )
        );
      });
    }
    // Update existing attachment
    if (existingAttachmentsToUpdate) {
      existingAttachmentsToUpdate.forEach(async (attachment) => {
        var attachmentFormData = new FormData();
        attachmentFormData.append("id", attachment.id);
        attachmentFormData.append(
          "caption_text",
          attachment.caption_text || attachment.captionText || null
        );
        attachmentFormData.append(
          "legal_document_id",
          attachment.legal_document_id || attachment.legalDocumentId || null
        );
        promiseAll.push(
          ApiCaller.put(`location_attachment/${site.id}`, attachmentFormData)
        );
      });
    }
    return Promise.all(promiseAll);
  }
  async updateImageCaption() {
    const { site, selectedCaptions } = this.state;
    this.setState({ isUploading: true });

    const promiseAll = [];
    Object.keys(selectedCaptions).forEach(async (photoAttribute, index) => {
      const submitData = new FormData();
      submitData.set(
        "caption_text",
        selectedCaptions[photoAttribute]["caption_text"]
      );

      promiseAll.push(
        api.fetchAPI({
          method: "post",
          body: submitData,
          uri: `locationfiles/${site.id}/photo_caption_update/${photoAttribute}`,
          success: (response) => {
            console.log(response);
          },
        })
      );
    });
    await Promise.all(promiseAll);
  }
  deleteAttachment(attachment_location_id, imageAttribute) {
    const confirm = window.confirm("Bạn có chắc sẽ xóa ảnh này?");
    if (!confirm) return;

    const { site } = this.state;

    api.fetchAPI({
      method: "put",
      body: {
        is_active: 0,
      },
      uri: `file_attachment/${attachment_location_id}`,
      success: (response) => {
        if (response.result) {
          site.photos[imageAttribute] = null;
          this.setState({ site });
        }
      },
    });
  }
  updateAttr(attribute, value) {
    const { site } = this.state;
    if (value == "") value = null;
    if (attribute === "city") {
      site["district"] = null;
      site["ward"] = null;
    }
    if (attribute === "district") {
      site["ward"] = null;
    }
    site[attribute] = value;
    this.setState({ site });
  }
  updateCustomAttributeData(attribute, value) {
    const { site, customAttributeData } = this.state;
    customAttributeData[attribute] = value;
    site["custom_attribute_data"] = JSON.stringify(customAttributeData);
    this.setState({ customAttributeData, site });
  }
  onPhotoCaptionChangeSelected(text, imageAttribute) {
    let { selectedCaptions, site } = this.state;
    if (!selectedCaptions) {
      selectedCaptions = {};
    }
    if (!selectedCaptions[imageAttribute]) {
      selectedCaptions[imageAttribute] = {};
    }
    selectedCaptions[imageAttribute]["caption_text"] = text;

    if (!site.photos[imageAttribute]) {
      site.photos[imageAttribute] = {};
    }

    if (!site.photos[imageAttribute]["caption_text"]) {
      site.photos[imageAttribute]["caption_text"] = "";
    }
    site.photos[imageAttribute]["caption_text"] = text;

    this.setState({ selectedCaptions, site });
  }
  onPhotoSelected(event, imageAttribute) {
    let { selectedPhotos, selectedCaptions, site } = this.state;
    if (!selectedPhotos) {
      selectedPhotos = {};
    }
    if (!selectedPhotos[imageAttribute]) {
      selectedPhotos[imageAttribute] = {};
    }
    if (!selectedCaptions[imageAttribute]) {
      selectedCaptions[imageAttribute] = {};
    }

    if (!site.photos) {
      site.photos = {};
    }
    if (!site.photos[imageAttribute]) {
      site.photos[imageAttribute] = {};
    }
    if (site.photos[imageAttribute]) {
      site.photos[imageAttribute]["caption_text"] = "";
      site.photos[imageAttribute]["url"] = "";
    }

    selectedPhotos[imageAttribute]["url"] = event.target.files[0];
    selectedCaptions[imageAttribute]["caption_text"] = "";
    this.setState({ selectedPhotos, site });
    // let { selectedPhotos } = this.state;
    // if (!selectedPhotos) {
    //   selectedPhotos = {};
    // }
    // selectedPhotos[imageAttribute] = event.target.files[0];
    // this.setState({ selectedPhotos });
  }
  // onImageClick(imageUrl) {
  //   this.setState({
  //     showLightBox: true,
  //     lightBoxPhotoIndex: 0,
  //     lightBoxImageArray: [imageUrl],
  //   });
  // }

  updateAttachmentToUpload = (attachmentToUpdate) => {
    const newAttachmentToUpload = this.state.attachmentToUploads || [];
    newAttachmentToUpload.forEach((attachment, index) => {
      if (attachment.url === attachmentToUpdate.url) {
        newAttachmentToUpload[index] = attachmentToUpdate;
      }
    });

    this.setState({ attachmentToUploads: newAttachmentToUpload });
  };
  attachFileButtonClick = () => {
    if (document.getElementById(this.fileInputId)) {
      document.getElementById(this.fileInputId).click();
    }
  };
  selectImagesToUpload = (event) => {
    const filesArray = Array.from(event.target.files);
    const newAttachmentToUploads = filesArray.map((file) => {
      return {
        blob: file,
        url: URL.createObjectURL(file),
      };
    });
    this.setState({
      attachmentToUploads: [
        ...this.state.attachmentToUploads,
        ...newAttachmentToUploads,
      ],
    });
  };
  deleteAttachmentToUpload = (url) => {
    const newAttachmentToUpload = this.state.attachmentToUploads.filter(
      (attachment) => attachment.url != url
    );
    this.setState({ attachmentToUploads: newAttachmentToUpload });
  };

  updateExistingAttachment = (attachmentToUpdate) => {
    const existingAttachments = this.state.existingAttachmentsToUpdate || [];
    existingAttachments.forEach((attachment, index) => {
      if (attachment.id === attachmentToUpdate.id) {
        existingAttachments[index] = attachmentToUpdate;
      }
    });
    this.setState({ existingAttachmentsToUpdate: existingAttachments });
  };
  deleteExistingAttachment = async (attachmentToDelete) => {
    const confirmationBox = window.confirm("Bạn có chắc sẽ xóa hình này?");
    if (!confirmationBox) return;
    const uri = `file_attachment/${attachmentToDelete.id}/delete`;
    const res = await ApiCaller.delete(uri);
    if (res.status === "ok") {
      const currentSiteData = this.state.site;
      this.setState({
        site: {
          ...currentSiteData,
          attachments: currentSiteData.attachments.filter(
            (attachment) => attachment.id != attachmentToDelete.id
          ),
        },
      });
    } else {
      alert(res.msg);
    }
  };
  findSiteLatLng() {
    const r = window.confirm(
      "Dữ liệu lat, lng lấy tự động có thể bị sai, vui lòng kiểm tra lại trên bản đồ và điều chỉnh nếu cần. Bạn có muốn tiếp tục?"
    );
    if (!r) return;
    const { site } = this.state;
    const full_address = `${site.address_number} ${site.street_name}, ${
      site.ward ? site.ward.name : ""
    }, ${site.district ? site.district.name : ""}, ${
      site.city ? site.city.name : ""
    }`;
    let uri = `location/geocoding/address_to_lat_lng?address=${full_address}`;
    if (site.plus_code) {
      uri = `${uri}&plus_code=${site.plus_code}`;
    }
    api.fetchAPI({
      method: "get",
      uri,
      success: (response) => {
        site.latitude = response.result.latitude;
        site.longitude = response.result.longitude;
        this.setState({ site });
      },
      error: (response) => {
        alert("Error: " + response.msg);
      },
    });
  }
  toggle(tab) {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }
  onImageClick = (imageUrl, imageArray) => {
    imageArray.map((url, idx) => {
      if (url === imageUrl) {
        this.setState({
          showLightBox: true,
          photoIndex: idx,
        });
      }
    });
  };
  render() {
    const {
      site,
      labelNames,
      isLoading,
      isUploading,
      selectedPhotos,
      isCreate,
      isView,
      activeTab,
      renderGroupList,
      selectedStatus,
      customAttributeData,
      customAttributeInfo,
      alertMessage,
      showLightBox,
      lightBoxImageArray,
      photoIndex,
      attachmentToUploads,
    } = this.state;
    if (!site) return null;
    if (isLoading) return <div>Đang tải...</div>;
    const { permissions } = site;
    let images = [];
    let imageTitles = [];
    let imageCaptions = [];
    if (site?.attachments) {
      const imageArray = site?.attachments?.filter(
        (attachment) => attachment.file_type === "image"
      );
      images = imageArray.map((attachment) => attachment.file_url);
      imageTitles = imageArray.map((attachment) => attachment.file_name);
      imageCaptions = imageArray.map((attachment) => attachment.caption_text);
    }
    return (
      <Container>
        {!isView && (
          <div>
            <h1>{isCreate ? "Tạo mới" : `Chỉnh sửa ${site.name}`}</h1>
            <div>
              <Button
                color={isLoading || isUploading ? "secondary" : "primary"}
                onClick={() => this.saveSite(true)}
                disabled={isLoading || isUploading}
              >
                {isLoading
                  ? "Đang lưu..."
                  : isUploading
                  ? "Đang upload hình"
                  : "Lưu"}
              </Button>{" "}
              {/* {!isCreate && (
                <Button
                  color={isLoading || isUploading ? "secondary" : "info"}
                  onClick={() => this.saveSite(false)}
                  disabled={isLoading || isUploading}
                >
                  {isLoading
                    ? "Đang lưu..."
                    : isUploading
                    ? "Đang upload hình"
                    : "Lưu"}
                </Button>
              )}{" "} */}
              {/* <Button
                color="warning"
                onClick={() => this.validateSiteInfoCheck()}
              >
                Kiểm tra dữ liệu
              </Button> */}
            </div>
          </div>
        )}
        {alertMessage && alertMessage.length > 0 && (
          <Row className="site-edit__error-message-on-save">
            <Col xs={12}>
              <Alert color="danger">
                <h4>Các thông tin còn thiếu:</h4>
                <ol>
                  {alertMessage.map((message) => (
                    <li key={message}>{message}</li>
                  ))}
                </ol>
              </Alert>
            </Col>
          </Row>
        )}
        <br />
        <Nav tabs className="site-edit__tabs">
          <NavItem>
            <NavLink
              className={`site-edit__tabs-nav-link ${
                activeTab === "1" ? "active" : ""
              }`}
              onClick={() => {
                this.toggle("1");
              }}
            >
              Thông tin chung
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`site-edit__tabs-nav-link ${
                activeTab === "2" ? "active" : ""
              }`}
              onClick={() => {
                this.toggle("2");
              }}
            >
              Hình ảnh
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <div className="site-edit__section">
              <h2 className="site-edit__section-title">Trạng thái</h2>
              <Row>
                <Col xs={12} sm={6}>
                  <Select
                    isDisabled={isView}
                    options={STATUS_FILTER.slice(1, STATUS_FILTER.length)}
                    value={selectedStatus}
                    onChange={(selectedOption) => {
                      const { site } = this.state;
                      site["external_status"] = selectedOption.value;
                      this.setState({
                        site,
                        selectedStatus: selectedOption,
                      });
                    }}
                  />
                  <br />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <Label className="site-attribute__text-input-label">
                    Mô hình kinh doanh
                  </Label>
                  <Input
                    className="site-attribute__text-input-box"
                    value={site.location_type.name}
                    disabled={true}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <Label className="site-attribute__text-input-label">
                    Thương hiệu
                  </Label>
                  <Input
                    className="site-attribute__text-input-box"
                    value={site.brand ? site.brand.name : ""}
                    disabled={true}
                  />
                </Col>
              </Row>
            </div>
            <div className="site-edit__section">
              <h2 className="site-edit__section-title">Vị trí địa điểm</h2>
              {renderGroupList.includes("1a") && (
                <div>
                  <Row>
                    <Col xs={12}>
                      <SiteTextInput
                        site={site}
                        labels={labelNames}
                        callback={this.updateAttr}
                        attributeName="name"
                        disabled={isView}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <SiteTextInput
                        site={site}
                        labels={labelNames}
                        callback={this.updateAttr}
                        attributeName="internal_code"
                        disabled={isView}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6}>
                      <SiteDropdownInput
                        apiUrl="city/"
                        callback={this.updateAttr}
                        value={{
                          label: site.city ? site.city.name : "",
                          value: site.city ? site.city.id : "",
                        }}
                        placeholder="Chọn thành phố"
                        site={site}
                        labels={labelNames}
                        attributeName="city"
                        disabled={isView}
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <SiteDropdownInput
                        apiUrl={`district/?q=(filters:!((col:city,opr:rel_o_m,value:${
                          site.city ? site.city.id : null
                        })))`}
                        callback={this.updateAttr}
                        value={{
                          label: site.district ? site.district.name : "",
                          value: site.district ? site.district.id : "",
                        }}
                        // filter={{
                        //   field: "city_id",
                        //   value: site.city ? site.city.id : null,
                        // }}
                        placeholder="Chọn quận, huyện"
                        site={site}
                        labels={labelNames}
                        attributeName="district"
                        disabled={isView}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6} md={2}>
                      <SiteTextInput
                        site={site}
                        labels={labelNames}
                        callback={this.updateAttr}
                        attributeName="address_number"
                        disabled={isView}
                      />
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                      <SiteTextInput
                        site={site}
                        labels={labelNames}
                        callback={this.updateAttr}
                        attributeName="street_name"
                        disabled={isView}
                      />
                    </Col>
                    <Col xs={12} sm={6} md={6}>
                      <SiteDropdownInput
                        apiUrl={`ward/?q=(filters:!((col:district,opr:rel_o_m,value:${
                          site.district ? site.district.id : null
                        })))`}
                        callback={this.updateAttr}
                        value={{
                          label: site.ward ? site.ward.name : "",
                          value: site.ward ? site.ward.id : "",
                        }}
                        // filter={{
                        //   field: "district_id",
                        //   value: site.district ? site.district.id : "",
                        // }}
                        placeholder="Chọn phường, xã"
                        site={site}
                        labels={labelNames}
                        attributeName="ward"
                        disabled={isView}
                      />
                      {/* <SiteTextInput
                        site={site}
                        labels={labelNames}
                        callback={this.updateAttr}
                        attributeName="ward_name"
                        disabled={isView}
                      /> */}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <SiteTextInput
                        site={site}
                        labels={labelNames}
                        callback={this.updateAttr}
                        attributeName="plus_code"
                        disabled={isView}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6} md={3}>
                      <SiteTextInput
                        site={site}
                        labels={labelNames}
                        callback={this.updateAttr}
                        attributeName="longitude"
                        disabled={isView}
                      />
                    </Col>
                    <Col xs={12} sm={6} md={3}>
                      <SiteTextInput
                        site={site}
                        labels={labelNames}
                        callback={this.updateAttr}
                        attributeName="latitude"
                        disabled={isView}
                      />
                    </Col>
                    {!isView && (
                      <Col xs={12} md={3}>
                        <Label>Lấy lat long tự động</Label>
                        <Button
                          color="info"
                          onClick={() => this.findSiteLatLng()}
                        >
                          Find Lat Long
                        </Button>
                      </Col>
                    )}
                    <Col xs={12}>
                      <SiteTextInput
                        textArea
                        site={site}
                        labels={labelNames}
                        callback={this.updateAttr}
                        attributeName="description"
                        disabled={isView}
                      />
                    </Col>
                  </Row>
                </div>
              )}
              {renderGroupList.includes("1b") && (
                <div>
                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="site-edit__attribute">
                        <SiteDropdownInput
                          apiUrl="site_type/?q=(filters:!((col:is_active,opr:eq,value:1)))"
                          callback={this.updateAttr}
                          value={{
                            label: site.store_site_type
                              ? site.store_site_type.name
                              : "",
                            value: site.store_site_type
                              ? site.store_site_type.id
                              : "",
                          }}
                          site={site}
                          labels={labelNames}
                          attributeName="store_site_type"
                          disabled={isView}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="site-edit__attribute">
                        <SiteDropdownInput
                          apiUrl="store_format/"
                          callback={this.updateAttr}
                          value={{
                            label: site.store_format
                              ? site.store_format.name
                              : "",
                            value: site.store_format
                              ? site.store_format.id
                              : "",
                          }}
                          site={site}
                          labels={labelNames}
                          attributeName="store_format"
                          disabled={isView}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="site-edit__attribute">
                        <SiteDropdownInput
                          apiUrl="site_surrounding_area_type/"
                          callback={this.updateAttr}
                          value={{
                            label: site.primary_site_surrounding_area_type
                              ? site.primary_site_surrounding_area_type.name
                              : "",
                            value: site.primary_site_surrounding_area_type
                              ? site.primary_site_surrounding_area_type.id
                              : "",
                          }}
                          site={site}
                          labels={labelNames}
                          attributeName="primary_site_surrounding_area_type"
                          disabled={isView}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="site-edit__attribute">
                        <SiteDropdownInput
                          apiUrl="site_surrounding_area_type/"
                          callback={this.updateAttr}
                          value={{
                            label: site.secondary_site_surrounding_area_type
                              ? site.secondary_site_surrounding_area_type.name
                              : "",
                            value: site.secondary_site_surrounding_area_type
                              ? site.secondary_site_surrounding_area_type.id
                              : "",
                          }}
                          placeholder="Chọn loại mặt bằng"
                          site={site}
                          labels={labelNames}
                          attributeName="secondary_site_surrounding_area_type"
                          disabled={isView}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="site-edit__attribute">
                        <SiteDropdownInput
                          apiUrl="site_position_type/"
                          callback={this.updateAttr}
                          value={{
                            label: site.site_position_type
                              ? site.site_position_type.name
                              : "",
                            value: site.site_position_type
                              ? site.site_position_type.id
                              : "",
                          }}
                          site={site}
                          labels={labelNames}
                          attributeName="site_position_type"
                          disabled={isView}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
            {renderGroupList.includes("2") && (
              <div className="site-edit__section">
                <h2 className="site-edit__section-title">Thông tin mặt bằng</h2>
                <Row>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="total_area"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="area"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="floor_count"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="facade_length"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="pavement_width"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="pavement_length"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                  <Col xs={12}>
                    <SiteTextInput
                      textArea
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="pavement_description"
                      disabled={isView}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    <SiteDropdownInput
                      apiUrl="parking_site_type/"
                      callback={this.updateAttr}
                      value={{
                        label: site.parking_site_type
                          ? site.parking_site_type.name
                          : "",
                        value: site.parking_site_type
                          ? site.parking_site_type.id
                          : "",
                      }}
                      placeholder="Vị trí bãi xe chính"
                      site={site}
                      labels={labelNames}
                      attributeName="parking_site_type"
                      disabled={isView}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="distance_from_parking_to_location"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="number_of_parking_cars"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="number_of_parking_bikes"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                  <Col xs={12}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="estimated_revenue_per_month_vnd"
                      disabled={isView}
                      isNumeric={true}
                    />
                  </Col>
                </Row>
              </div>
            )}
            {renderGroupList.includes("3") && (
              <div className="site-edit__section">
                <h2 className="site-edit__section-title">Chi phí mặt bằng</h2>
                <Row>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="lease_rate"
                      isNumeric
                      disabled={isView}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="lease_term_year"
                      isNumeric
                      disabled={isView}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    <Label>{labelNames.available_to}</Label>
                    <DatePicker
                      selected={
                        site.available_to
                          ? moment(site.available_to, "YYYY-MM-DD").toDate()
                          : null
                      }
                      onChange={(date) =>
                        this.updateAttr(
                          "available_to",
                          moment(date).format("YYYY-MM-DD")
                        )
                      }
                      dateFormat="yyyy-MM-dd"
                      disabled={isView}
                    />
                  </Col>
                </Row>
              </div>
            )}
            {renderGroupList.includes("4") && (
              <div className="site-edit__section">
                <h2 className="site-edit__section-title">
                  Thông tin chủ mặt bằng / người cho thuê mặt bằng
                </h2>
                <Row>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="contact_name"
                      disabled={isView}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="contact_phone"
                      disabled={isView}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <SiteTextInput
                      site={site}
                      labels={labelNames}
                      callback={this.updateAttr}
                      attributeName="contact_email"
                      disabled={isView}
                    />
                  </Col>
                </Row>
              </div>
            )}
            {/* {renderGroupList.includes("4") && !isView && (
              <div className="site-edit__section">
                <h2 className="site-edit__section-title">Hình ảnh</h2>
                <Row>
                  {constants.SITE_IMAGE_ATTRIBUTES.map((imageAttribute) => (
                    <Col xs={12} sm={6} key={imageAttribute}>
                      {!isView && (
                        <div>
                          <FormGroup>
                            <Label>{labelNames[imageAttribute]}</Label>
                            <Input
                              type="file"
                              onChange={(event) =>
                                this.onPhotoSelected(event, imageAttribute)
                              }
                            >
                              Chọn ảnh nha
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Input
                              type="text"
                              placeholder="Ghi chú"
                              value={
                                site &&
                                site.photos &&
                                site.photos[imageAttribute]
                                  ? site.photos[imageAttribute]["caption_text"]
                                  : ""
                              }
                              onChange={(event) =>
                                this.onPhotoCaptionChangeSelected(
                                  event.target.value,
                                  imageAttribute
                                )
                              }
                            />
                          </FormGroup>
                          {selectedPhotos && (
                            <div className="site-edit__img-container">
                              {selectedPhotos[imageAttribute] &&
                                selectedPhotos[imageAttribute]["url"] && (
                                  <img
                                    className="site-edit__img"
                                    src={URL.createObjectURL(
                                      selectedPhotos[imageAttribute]["url"]
                                    )}
                                  />
                                )}
                            </div>
                          )}
                        </div>
                      )}
                      {site.photos && (
                        <div className="site-edit__img-container">
                          {isView && (
                            <Label>{labelNames[imageAttribute]}</Label>
                          )}
                          {selectedPhotos &&
                          selectedPhotos[imageAttribute] &&
                          selectedPhotos[imageAttribute] ? null : (
                            <div>
                              {site.photos[imageAttribute] &&
                                site.photos[imageAttribute]["url"] && (
                                  <div>
                                    <img
                                      className="site-edit__img"
                                      src={site.photos[imageAttribute]["url"]}
                                    />
                                    <Button
                                      size="sm"
                                      color="danger"
                                      onClick={() =>
                                        this.deleteAttachment(
                                          site.photos[imageAttribute][
                                            "attachment_location_id"
                                          ],
                                          imageAttribute
                                        )
                                      }
                                    >
                                      Xóa
                                    </Button>
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      )}
                    </Col>
                  ))}
                </Row>
              </div>
            )} */}
            <div className="site-edit__section">
              <h2 className="site-edit__section-title">Thông tin đặc trưng</h2>
              <div>
                {site.location_type.id === 12 && (
                  <Row>
                    <Col xs={12} sm={6}>
                      <Label className="site-attribute__text-input-label">
                        Doanh thu dự đoán (theo số quầy cashier)
                      </Label>
                      <Input
                        className="site-attribute__text-input-box"
                        value={
                          customAttributeData.number_of_casiers == 2
                            ? "Dưới 2 tỷ"
                            : customAttributeData.number_of_casiers == 3 ||
                              customAttributeData.number_of_casiers == 4
                            ? "Dưới 3 tỷ"
                            : "Chưa xác định"
                        }
                        disabled={true}
                      />
                    </Col>
                  </Row>
                )}
                <Row>
                  {customAttributeInfo.map((item, index) => {
                    if (item.type == "select") {
                      return (
                        <Col xs={12} sm={6} key={index}>
                          <div style={styles.customAtributeItem}>
                            <label>{item.name}</label>
                            <Select
                              placeholder=""
                              isDisabled={isView}
                              options={
                                CUSTOM_ATTRIBUTE_SELECT_OPTION[item.code_name]
                              }
                              value={CUSTOM_ATTRIBUTE_SELECT_OPTION[
                                item.code_name
                              ].find(
                                (object) =>
                                  object.value ==
                                  customAttributeData[item.code_name]
                              )}
                              onChange={(selectedOption) => {
                                this.updateCustomAttributeData(
                                  item.code_name,
                                  selectedOption.value
                                );
                              }}
                            />
                          </div>
                        </Col>
                      );
                    } else {
                      return (
                        <Col xs={12} sm={6} key={index}>
                          <div style={styles.customAtributeItem}>
                            <Label className="site-attribute__text-input-label">
                              {item.name}
                            </Label>
                            <Input
                              className="site-attribute__text-input-box"
                              onChange={(e) =>
                                this.updateCustomAttributeData(
                                  item.code_name,
                                  item.type === "integer"
                                    ? e.target.value.replace(/\D/g, "")
                                    : e.target.value
                                )
                              }
                              value={customAttributeData[item.code_name]}
                              disabled={isView}
                            />
                          </div>
                        </Col>
                      );
                    }
                  })}
                </Row>
                {site.location_type.id === 8 && (
                  <Row>
                    <Col xs={12} sm={6}>
                      <Label className="site-attribute__text-input-label">
                        Tổng số hộ
                      </Label>
                      <Input
                        className="site-attribute__text-input-box"
                        value={
                          customAttributeData.number_of_block *
                            customAttributeData.number_of_floor_per_block *
                            customAttributeData.number_of_house_per_floor || 0
                        }
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <br />
                      <Label className="site-attribute__text-input-label">
                        Phân khúc chung cư
                      </Label>
                      <Input
                        className="site-attribute__text-input-box"
                        value={
                          customAttributeData.lending_rate >= 20000000
                            ? "Cao cấp"
                            : customAttributeData.lending_rate >= 10000000
                            ? "Trung cao"
                            : "Trung"
                        }
                        disabled={true}
                      />
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </TabPane>
          <TabPane tabId="2">
            <div className="site-edit__section">
              <h2 className="site-edit__section-title">Hình ảnh</h2>
              <Row>
                {!isView && (
                  <Col xs={12} sm={6}>
                    <div style={styles.actionSheet}>
                      <Button
                        outline
                        color="primary"
                        onClick={this.attachFileButtonClick}
                        style={styles.commentButton}
                      >
                        <i className="material-icons">insert_photo</i>
                        <span>Đính kèm file</span>
                      </Button>
                      <Input
                        type="file"
                        label="Chọn file nào..."
                        title=""
                        id={this.fileInputId}
                        multiple
                        hidden
                        style={styles.selectFileButton}
                        onChange={this.selectImagesToUpload}
                        key={this.fileInputId}
                      />
                    </div>
                  </Col>
                )}
                <Row style={styles.attachmentContainer}>
                  {attachmentToUploads.length > 0 && (
                    <Fragment>
                      {attachmentToUploads.map((attachment, index) => (
                        <Col xs={12} sm={6} key={`attachment-index-${index}`}>
                          <div style={styles.attachmentWrapper}>
                            <Image
                              isView={isView}
                              attachment={attachment}
                              onAttachmentToUploadDeleted={(attachment) =>
                                this.deleteAttachmentToUpload(attachment.url)
                              }
                              onAttachmentUpdated={(attachmentAfterUpdated) =>
                                this.updateAttachmentToUpload(
                                  attachmentAfterUpdated
                                )
                              }
                            />
                          </div>
                        </Col>
                      ))}
                    </Fragment>
                  )}
                  {site?.attachments?.map((attachment) => {
                    // Do not show legal document files on this tab
                    if (
                      attachment.attachment_content_relation_type ===
                      "legal_document"
                    )
                      return null;
                    return (
                      <Col xs={12} sm={6} key={`${attachment.id}`}>
                        <div style={styles.attachmentWrapper}>
                          <Image
                            isView={isView}
                            attachment={attachment}
                            isExistingAttachment
                            onAttachmentUpdated={(attachmentAfterUpdated) =>
                              this.updateExistingAttachment(
                                attachmentAfterUpdated
                              )
                            }
                            onExistingAttachmentDeleted={(attachment) =>
                              this.deleteExistingAttachment(attachment)
                            }
                            onImageClick={(attachment) =>
                              this.onImageClick(attachment.file_url, images)
                            }
                          />
                        </div>
                      </Col>
                    );
                  })}
                  {showLightBox && (
                    <Lightbox
                      mainSrc={images[photoIndex]}
                      nextSrc={images[(photoIndex + 1) % images.length]}
                      prevSrc={
                        images[(photoIndex + images.length - 1) % images.length]
                      }
                      onCloseRequest={() =>
                        this.setState({
                          showLightBox: false,
                        })
                      }
                      onMovePrevRequest={() =>
                        this.setState({
                          photoIndex:
                            (photoIndex + images.length - 1) % images.length,
                        })
                      }
                      onMoveNextRequest={() =>
                        this.setState({
                          photoIndex: (photoIndex + 1) % images.length,
                        })
                      }
                      imageTitle={imageTitles[photoIndex]}
                      imageCaption={imageCaptions[photoIndex]}
                    />
                  )}
                </Row>
                {/* {constants.SITE_IMAGE_ATTRIBUTES.map((eachAttribute) => {
                  const imageAttribute = eachAttribute.key;
                  const imageName = eachAttribute.name;
                  return (
                    <Col xs={12} sm={6} md={4} key={imageAttribute}>
                      <div className="location-photo-item">
                        <div>
                          <FormGroup>
                            <h4 className="site-edit__img-name">
                              {labelNames[imageAttribute.key] || imageName}
                            </h4>
                            {!isView && (
                              <Input
                                type="file"
                                onChange={(event) =>
                                  this.onPhotoSelected(event, imageAttribute)
                                }
                              >
                                Chọn ảnh nha
                              </Input>
                            )}
                          </FormGroup>
                          {!isView && (
                            <FormGroup>
                              <Input
                                type="text"
                                placeholder="Ghi chú"
                                value={
                                  site &&
                                  site.photos &&
                                  site.photos[imageAttribute]
                                    ? site.photos[imageAttribute][
                                        "caption_text"
                                      ]
                                    : ""
                                }
                                onChange={(event) =>
                                  this.onPhotoCaptionChangeSelected(
                                    event.target.value,
                                    imageAttribute
                                  )
                                }
                              />
                            </FormGroup>
                          )}
                          {selectedPhotos && (
                            <div className="site-edit__img-container">
                              {selectedPhotos[imageAttribute] &&
                                selectedPhotos[imageAttribute]["url"] &&
                                (selectedPhotos[imageAttribute]["file_type"] ==
                                "video" ? (
                                  <video
                                    controls
                                    className="site-image-component__video"
                                  >
                                    <source
                                      src={
                                        selectedPhotos[imageAttribute]["url"]
                                      }
                                    />
                                  </video>
                                ) : (
                                  <img
                                    className="site-edit__img"
                                    src={URL.createObjectURL(
                                      selectedPhotos[imageAttribute]["url"]
                                    )}
                                  />
                                ))}
                            </div>
                          )}
                        </div>
                        {site.photos && (
                          <div className="site-edit__img-container">
                            {selectedPhotos &&
                            selectedPhotos[imageAttribute] &&
                            selectedPhotos[imageAttribute] ? null : (
                              <div>
                                {site.photos[imageAttribute] &&
                                site.photos[imageAttribute]["url"] ? (
                                  <div className="site-edit__img-inner">
                                    <div>
                                      {site.photos[imageAttribute][
                                        "file_type"
                                      ] == "video" ? (
                                        <video
                                          controls
                                          className="site-image-component__video"
                                        >
                                          <source
                                            src={
                                              site.photos[imageAttribute]["url"]
                                            }
                                          />
                                        </video>
                                      ) : (
                                        <div
                                          className="site-edit__img"
                                          onClick={() => this.onImageClick(site.photos[imageAttribute]["url"])}
                                          style={{
                                            backgroundImage: `url(${site.photos[imageAttribute]["url"]})`,
                                          }}
                                        />
                                      )}
                                    </div>
                                    {!isView && (
                                      <Button
                                        className="site-edit__img-delete-button"
                                        size="sm"
                                        color="danger"
                                        onClick={() =>
                                          this.deleteAttachment(
                                            site.photos[imageAttribute][
                                              "attachment_location_id"
                                            ],
                                            imageAttribute
                                          )
                                        }
                                      >
                                        Xóa
                                      </Button>
                                    )}
                                  </div>
                                ) : (
                                  <div
                                    className="site-edit__img"
                                    style={{
                                      backgroundImage: `url(${PhotoPlaceholder})`,
                                    }}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {isView && (
                          <p className="site-edit__img-caption">
                            {site && site.photos && site.photos[imageAttribute]
                              ? site.photos[imageAttribute]["caption_text"]
                              : ""}
                          </p>
                        )}
                      </div>
                    </Col>
                  );
                })} */}
              </Row>
            </div>
          </TabPane>
        </TabContent>
      </Container>
    );
  }
}

const styles = {
  customAtributeItem: {
    marginBottom: 16,
  },
  attachmentContainer: {
    marginBottom: 48,
    marginTop: 24,
    marginLeft: 0,
    marginRight: 0,
    width: '100%'
  },
};

const CUSTOM_ATTRIBUTE_SELECT_OPTION = {
  car_parking: [
    {
      label: "Không có",
      value: "Không có",
    },
    {
      label: "Đậu xe hơi miễn phí",
      value: "Đậu xe hơi miễn phí",
    },
    {
      label: "Đậu xe hơi có tính phí",
      value: "Đậu xe hơi có tính phí",
    },
  ],
  main_road_ways: [
    {
      label: "Đường 1 chiều",
      value: "Đường 1 chiều",
    },
    {
      label: "Đường 2 chiều",
      value: "Đường 2 chiều",
    },
  ],
  is_flooded_with_tide: [
    {
      label: "Có",
      value: "Có",
    },
    {
      label: "Không",
      value: "Không",
    },
  ],
  is_flooded_with_rain: [
    {
      label: "Có",
      value: "Có",
    },
    {
      label: "Không",
      value: "Không",
    },
  ],
  external_environmental_factors: [
    {
      label: "Lô cốt",
      value: "Lô cốt",
    },
    {
      label: "Công trình đang xây dựng",
      value: "Công trình đang xây dựng",
    },
    {
      label: "Đường 2 chiều đổi thành 1 chiều",
      value: "Đường 2 chiều đổi thành 1 chiều",
    },
    {
      label: "Có cầu vượt",
      value: "Có cầu vượt",
    },
  ],
  primary_customer_group: [
    {
      label: "Sinh viên",
      value: "Sinh viên",
    },
    {
      label: "Nhân viên văn phòng",
      value: "Nhân viên văn phòng",
    },
    {
      label: "Freelancer",
      value: "Freelancer",
    },
    {
      label: "Dân cư xung quanh",
      value: "Dân cư xung quanh",
    },
    {
      label: "Khách du lịch",
      value: "Khách du lịch",
    },
    {
      label: "Nhân viên nhà nước",
      value: "Nhân viên nhà nước",
    },
  ],
  secondary_customer_group: [
    {
      label: "Sinh viên",
      value: "Sinh viên",
    },
    {
      label: "Nhân viên văn phòng",
      value: "Nhân viên văn phòng",
    },
    {
      label: "Freelancer",
      value: "Freelancer",
    },
    {
      label: "Dân cư xung quanh",
      value: "Dân cư xung quanh",
    },
    {
      label: "Khách du lịch",
      value: "Khách du lịch",
    },
    {
      label: "Nhân viên nhà nước",
      value: "Nhân viên nhà nước",
    },
  ],
  forecasted_revenue: [
    {
      label: "Dưới 2 tỷ",
      value: "Dưới 2 tỷ",
    },
    {
      label: "Dưới 3 tỷ",
      value: "Dưới 3 tỷ",
    },
    {
      label: "Dưới 4 tỷ",
      value: "Dưới 4 tỷ",
    },
  ],
  wc_location: [
    {
      label: "WC trong toà nhà",
      value: "WC trong toà nhà",
    },
    {
      label: "WC của mặt bằng",
      value: "WC của mặt bằng",
    },
  ],
};
